module.exports = __webpack_public_path__ + "static/media/gestaoedesenvolvimento.a07ae6a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/box_courses/gestaoedesenvolvimento.jpg
// module id = 26
// module chunks = 0